import React, { SVGProps } from 'react'
const SvgProfile = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="nonzero"
      d="M11.714 4.067c4.536 0 8.215 3.648 8.215 8.15 0 4.502-3.679 8.15-8.215 8.15-4.535 0-8.214-3.648-8.214-8.15 0-4.502 3.679-8.15 8.214-8.15Zm.089 12.23c-2.471 0-3.8.594-4.107 1.858a7.217 7.217 0 0 0 4.018 1.212c1.553 0 2.991-.486 4.168-1.313-.353-1.196-1.677-1.757-4.08-1.757Zm-.089-11.23c-3.985 0-7.214 3.202-7.214 7.15 0 2.092.907 3.975 2.353 5.283.401-1.013 1.343-1.685 2.792-1.999a3.263 3.263 0 0 1-1.148-2.486c0-1.813 1.481-3.282 3.306-3.282 1.824 0 3.305 1.469 3.305 3.282 0 .994-.445 1.885-1.148 2.487 1.392.3 2.316.933 2.744 1.878a7.098 7.098 0 0 0 2.225-5.163c0-3.948-3.23-7.15-7.215-7.15Zm.089 5.666a2.294 2.294 0 0 0-2.306 2.282 2.294 2.294 0 0 0 2.306 2.282 2.294 2.294 0 0 0 2.305-2.282 2.294 2.294 0 0 0-2.305-2.282Z"
    />
  </svg>
)
export default SvgProfile
